import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';

import { palette } from '../../themes/theme';
import RoundPause from '../../assets/roundPause.svg?react';
import RoundPlay from '../../assets/roundPlay.svg?react';

import ProgressBar from './ProgressBar';
import { createImageUrl } from '../../services/data';
import { formatTime } from '../../services/formatFunctions';
import { safePlay } from '../../utils/errorHandler';
import { trackAudioPlayed, trackAudioFinished } from '../../mixpanel';
import { useParams } from 'react-router-dom';
import { APP_ANNEFRANK } from '../../constants/apps';

interface LegacyAudioPlayerProps {
  audio: string;
  name?: string;
}

const AudioPlayer: React.FC<LegacyAudioPlayerProps> = ({audio, name}) => {
    const [isPlaying, setIsPlaying] = useState<boolean>(false)
    const [duration, setDuration] = useState<number>(0)
    const [currentTime, setCurrentTime] = useState<number>(0);
    const audioRef = useRef<HTMLAudioElement>(null)
    const hasTrackedPlay = useRef(false)
    const {slug} = useParams()

    useEffect(() => {
        if (!isPlaying) {
            audioRef.current?.pause();
        } else {
            safePlay(audioRef.current);
            if (!hasTrackedPlay.current) {
                hasTrackedPlay.current = true;
                trackAudioPlayed(name ?? '');
            }
        }
    }, [isPlaying]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleLoadeMetaData = () => {
        if (audioRef.current) setDuration(audioRef.current.duration);
    }

    const handleTimeUpdate = () => {
        if (audioRef.current) setCurrentTime(audioRef.current.currentTime);
    }

    const handleSeek = (time: number) => {
        if (audioRef.current) audioRef.current.currentTime = time;
    }

    const handleEnded = () => {
        setIsPlaying(false);
        hasTrackedPlay.current = false;
        trackAudioFinished(name ?? '');
    }

    return (
        <Box width='100%'>
            <Box >
                <audio
                    ref={audioRef}
                    src={createImageUrl(audio)}
                    onLoadedMetadata={handleLoadeMetaData}
                    onTimeUpdate={handleTimeUpdate}
                    onEnded={handleEnded}
                />
            </Box>
            <ProgressBar
                playerRef={audioRef}
                progress={currentTime}
                totalDuration={duration}
                onSeek={handleSeek}
            />
            <div className="time" style={{display: 'flex', justifyContent: 'space-between'}}>
                <p>{formatTime(currentTime)}</p>
                <p>{formatTime(duration)}</p>

            </div>
            {/* notranslate: transport controls — Google Translate's DOM edits
                break React reconciliation on iOS (Sentry CUSTOM-APP-D). */}
            <div className='access notranslate' translate='no' style={{textAlign: 'center'}}>
                <button disabled={duration === 0} style={{height: '8vh', width: '11vh', backgroundColor: slug === APP_ANNEFRANK ? palette.brand.gold : 'transparent', border: 'none', cursor: 'pointer', filter: slug !== APP_ANNEFRANK ? 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' : 'none'}} onClick={() => setIsPlaying(!isPlaying)}>
                    {isPlaying? <RoundPause aria-label='pause' width='100%' height='100%'/> : <RoundPlay aria-label='play' width='100%' height='100%'/>}
                </button>
            </div>
        </Box>
    );
};

export default AudioPlayer;
